import { useContext, useState } from 'react'
import BaseMobileAppContainer from '../mobile/base-mobile-app-container/BaseMobileAppContainer'
import Styles from "./Feedback.module.scss";
import { useDispatch } from 'react-redux'
import { APP_KEY_IDS } from '../../constants/constants'
import { closeWindow } from '../../actions'
import BaseNativeAppContainer from '../base-native-app-container/BaseNativeAppContainer';
import { child, getDatabase, ref, set } from 'firebase/database';
import { AppContext } from '../../contexts/AppContext';
import { ToastContext } from '../../contexts/toast/ToastContextProvider';
import { AuthContext } from '../../contexts/AuthContext';
import classnames from "classnames"
import { getDateTimeFromTimestamp } from '../../global/functions/functrions';

const Feedback = () => {

    const { isMobile } = useContext(AppContext)

    return (
        <>
            {
                isMobile
                    ? <BaseMobileAppContainer
                        appId={APP_KEY_IDS.FEEDBACK
                        }
                        title=''
                        MainScreen={
                            <MainComponent />
                        }
                        isMainScreenActive={true}
                    />
                    : <BaseNativeAppContainer
                        appId={APP_KEY_IDS.FEEDBACK}
                        loadFromX={0}
                        title='Feedback'
                        height={544}
                        width={780}
                        MainScreen={
                            <MainComponent />
                        }
                    />
            }
        </>
    )
}

export default Feedback


const MainComponent = () => {

    const { showToast } = useContext(ToastContext)

    const { isMobile } = useContext(AppContext)

    const { userId, userName, isLoggedIn } = useContext(AuthContext)

    const database = getDatabase();

    const dispatch = useDispatch()

    const [feedback, setFeedback] = useState("")

    const handleSubmit = () => {

        let message = ""

        if (userId) {

            if (feedback) {
                const dbRef = child(ref(database), `feedbacks/${userId + "_" + (new Date())}`)

                set(dbRef, {
                    userName: userName,
                    userId: userId,
                    feedback: feedback,
                    createdAt:getDateTimeFromTimestamp(Date.now())
                })
                message="You feedback has been submitted successfully. Thanks for your feedback"
                dispatch(closeWindow(APP_KEY_IDS.FEEDBACK))
            }
            else {
                message="You have not enetered the feedback"
            }

        }
        else {
            message="Kindly make sure you are logged in. Click here to login"
        }

        showToast({
            [`feedbackAt_${Date.now()}`]: {
                appId: APP_KEY_IDS.FEEDBACK,
                appName: "Feedback",
                bannerImage: "",
                mobileAppId: APP_KEY_IDS.MOBILE_FEEDBACK,
                subText: message,
                time: getDateTimeFromTimestamp(Date.now()),
                title: "Feedback Status",
                visitLink: ""
            }
        })

    }

    return (
        < div className={classnames(Styles.feedback,"glassBackground")} >
            <div className={Styles.fdhead}>{isMobile ? "Feedback" : "Enter your Feedback"}</div>
            <textarea className={Styles.feedback_input} placeholder="Enter your name and feedback here...." onChange={(e) => setFeedback(e.target.value)} value={feedback} required></textarea>
            <div className={Styles.buttons}>
                <button className={Styles.submit} onClick={handleSubmit}>Ok</button>
                <button className={Styles.cancel} onClick={() => { dispatch(closeWindow(APP_KEY_IDS.FEEDBACK)) }}>Cancel</button>
            </div>
        </div >
    )
}
